import React, {useState} from "react";
import {Box, Divider, Stack, Typography} from "@mui/material";
import {GenerationPRChart} from "../GenerationPRChart/GenerationPR";
import {GenerationPRChartComparison} from "../GenerationPRChartComparison/GenerationPRComparisonChart";
import {
    ACard,
    Period,
    PeriodSelector,
    PeriodSelectorGroupBy,
    AToggleButtonGroup
} from "@atiautomacao/ati-ui-library";
import IconButton from "@mui/material/IconButton";
import {useAppSelector} from "../../../Config/Hooks";
import {hasPermission} from "../../../Shared/Auth/AuthenticationUtil";
import {AUTHORITIES} from "../../../Config/Constants";
import { ChangeCircleOutlined, SimCardDownloadOutlined } from "@mui/icons-material";

interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
}

function TabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ p: 0, m: 0 }}>
                    {children}
                </Box>
            )}
        </div>
    );
}
export default function PRComparison() {
    const openSubMenu = useAppSelector((state: any) => state.layout.openSubMenu);
    const account = useAppSelector(state => state.authentication.account);
    const isAuthorizedToSearchByPdf = hasPermission(account?.authoritySet, [
        AUTHORITIES.SYSADMIN, AUTHORITIES.VIEW_PDF_EXPORT, AUTHORITIES.EXPORT_PR, AUTHORITIES.PDF_EXPORT_PR
    ]);
    const isAuthorizedToSearchByCsv = hasPermission(account?.authoritySet, [
        AUTHORITIES.SYSADMIN, AUTHORITIES.VIEW_CSV_EXPORT, AUTHORITIES.EXPORT_PR, AUTHORITIES.CSV_EXPORT_PR
    ]);
    const isAuthorizedToSearchByExcel = hasPermission(account?.authoritySet, [
        AUTHORITIES.SYSADMIN, AUTHORITIES.VIEW_EXCEL_EXPORT, AUTHORITIES.EXPORT_PR, AUTHORITIES.EXCEL_EXPORT_PR
    ]);
    const [prValue, setPrValue] = React.useState("0");

    const initialPRPeriod: Period = {
        groupBy: "week",
        fromDateTime: new Date(),
        toDateTime: new Date()
    };
    const initialPRComparisonPeriod: Period = {
        groupBy: "week",
        fromDateTime: new Date(),
        toDateTime: new Date()
    };

    const prGroupsInterval = {
        day: {date: new Date(), startTime: "00:00:00", endTime: "23:59:59"},
        week: {startTime: "00:00:00", endTime: "23:59:59", startInterval: 6},
        month: {startTime: "00:00:00", endTime: "23:59:59", startInterval: 30},
        year: {startTime: "00:00:00", endTime: "23:59:59", startInterval: 11},
    };
    const prGroups : PeriodSelectorGroupBy[] = ["day", "week", "month", "year"];

    const [period, setPeriod] = useState<Period>(prValue === "0" ? initialPRPeriod : initialPRComparisonPeriod);


    // SGD-3375: respeita o groupBy escolhido pelo usuário. Antes o handler sobrescrevia o groupBy
    // de volta pro inicial ("week"/7 dias) a cada clique, revertendo Dia/31 Dias/12 Meses.
    const handleTabChange = (period: Period) => {
        setPeriod(period);
    }

    const handleChangePR =  (event: React.MouseEvent<HTMLElement>, value: string | null) => {
            setPrValue(value ?? "0");
    };

    return (
        <ACard
            title="Desempenho das Usinas"
            ariaLabel={"dashboard-overview-pr-comparison"}
            key={`chart-skid-active-power`}
            styleProps={{
               cardStyle: { height: 463},
                contentStyle: { padding: '0 16px', height: 408, alignItems: 'center'},
                titleStyle: { alignItems: 'center', display: 'flex' },
                subTitleStyle: { display: 'none' },
                headerStyle: { flexDirection: 'row' },
                headerActionsStyle: { alignItems: 'center', display: 'flex'},
            }}
            headerControlsPosition={"header"}
            headerControls={
                <Stack direction="row" spacing={2}>
                    <PeriodSelector
                        styleProps={{base: {flexDirection: "row", display: "flex", alignItems: "center", padding: '8px 0'}}}
                        mode="hybrid"
                        hideDatetime={false}
                        disableHourSelector={true}
                        inputFormat={'dd/MM/yyyy'}
                        hideGroup={false}
                        periodInterval={prGroupsInterval}
                        period={period}
                        onChange={handleTabChange}
                        groupByOptions={prGroups}
                    />
                </Stack>
            }
            headerActions={
                <Stack direction="column" spacing={"8px"}>
                    <Box sx={{ display: 'flex',alignItems: 'center', justifyContent: 'space-between', padding: '0 12px'}}>
                        <IconButton disabled={true} size="small" >
                            <SimCardDownloadOutlined sx={{marginRight: '12px'}}/>
                            <Typography variant="body2">Baixar como CSV</Typography>
                        </IconButton>
                    </Box>
                    <Divider/>
                    <Box sx={{ display: 'flex',alignItems: 'center', justifyContent: 'space-between', padding: '0 12px' }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', paddingRight: '32px' }}>
                            <IconButton sx={{borderRadius: '4px'}} size="small" onClick={() => setPrValue("0")}>
                                <ChangeCircleOutlined  sx={{marginRight: '12px'}}/>
                                <Typography variant="body2">Alterar visão</Typography>

                            </IconButton>
                           
                        </Box>
                        <AToggleButtonGroup
                            styleProps={{
                                toggleButtonGroup: {
                                    paddingLeft: '4px',
                                    height: '30px',
                                },
                                toggleButton: {
                                    height: '30px',
                                },
                                typography: {
                                    fontSize: '14px',
                                },
                            }}
                            options={[
                                { value: "0", label: 'Comparativo' },
                                { value: "1", label: 'Absoluto' },
                            ]}
                            value={prValue}
                            exclusive
                            onChange={handleChangePR}
                        
                        />
                    </Box>
                    <Divider />
                </Stack>
            }
        >
            { prValue === "0" ?
                    <GenerationPRChart period={period}/>
                :
                    <GenerationPRChartComparison period={period}/>
            }
        </ACard>
    )
}